import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import icon_details from '../../../assets/images/details1.png'
import name_icon from '../../../assets/images/id-card.png'
import email_icon from '../../../assets/images/mail.png'
import number_icon from '../../../assets/images/number-blocks.png'
import date_icon from '../../../assets/images/calendar.png'
import price_icon from '../../../assets/images/price-tag.png'
import accounts from '../../../assets/images/accounts.png'
import '../accounts/Accounts.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import DivInfo from '../accounts/DivInfo';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { emptyOneStatement, loadOneStatement } from '../../../store/Actions/ActionStatements';
import moment from 'moment';
import InnerLoader from '../../../components/general/inner-loader/InnerLoader';

function PopUpDetails({ statement_id, open, setOpen }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { one_statement, loadingOneStatement } = useSelectorCustom()
    useEffect(() => {
        dispatch(loadOneStatement(statement_id))
    }, [])

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
                dispatch(emptyOneStatement())
            }}
            center
            classNames={{
                modal: `pop_center_details`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_material' dir={langLocal == "ar" ? "rtl" : "ltr"}  >
                <div className='top-details' >
                    <img src={icon_details} />
                </div>
                <div className='user-info' >
                    {
                        loadingOneStatement ? <div ><InnerLoader /></div> :
                            <>
                                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""} style={{ marginBottom: "5px" }} >{translate('all_info')}</h3>
                                <div >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('statement_number')} data={one_statement?.number} img={number_icon} />
                                        <DivInfo langLocal={langLocal} title={translate('statement_date')} data={moment(one_statement?.statement_date).format("YYYY-MM-DD")} img={date_icon} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('account_name')} data={one_statement?.account?.name} img={accounts} />
                                        <DivInfo langLocal={langLocal} title={translate('project_name')} data={one_statement?.project?.name} img={name_icon} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('type')} data={one_statement?.type?.label} img={name_icon} />
                                    </div>
                                    <div  >
                                        <div className='one-user-info' style={{ width: "100%" }} dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                                            <div className='two-flex' >
                                                <div className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_15"} circle-div-info`} ></div>
                                                <span className='title-user-info' >{translate('production_crew')} </span>
                                            </div>
                                            {
                                                one_statement?.project?.production_crews?.map((crew) => {
                                                    return (
                                                        <span className={`${langLocal == 'ar' ? "textAlignRight margin_right_20" : "margin_left_25"} data-user-info`}>
                                                            {
                                                                crew?.status && (
                                                                    <>{crew?.name} / {crew?.production_crew?.name}</>
                                                                )
                                                            }
                                                        </span>
                                                    )
                                                })
                                            }

                                        </div>
                                    </div>
                                </div>
                            </>
                    }

                </div>
            </div>
        </RModal>
    )
}

export default PopUpDetails